/** Represents type of linking of conditions in group (predicate).*/
export var LinkType;
(function (LinkType) {
    /**
     * None of the conditions must be truth (all must be false).
     * In SQL it will look like: `NOT (Condition1 OR Condition2 OR ...)`.
     */
    LinkType[LinkType["None"] = 0] = "None";
    /** At least one condition must be truth. In SQL they are connected by `OR` operator.*/
    LinkType[LinkType["Any"] = 1] = "Any";
    /**
     * Not all conditions must be truth (at least one must false).
     * In SQL it will look like: `NOT(Condition1 AND Condition2 AND ...)`.
     */
    LinkType[LinkType["NotAll"] = 2] = "NotAll";
    /** All conditions must be truth, in result SQL they are connected by `AND` operator;*/
    LinkType[LinkType["All"] = 3] = "All";
})(LinkType || (LinkType = {}));
//# sourceMappingURL=link_type.js.map